import React from 'react';
import styles from '../../index.module.scss';
import Button from 'components/Button';
import Icon from 'components/Icon';
import toolsEventMap from 'components/ReaderTools/toolsEventMap';
import { useGAEvent } from 'components/AppService/GAService';

import { withTranslation } from 'react-i18next';

const ReaderToolPageModeComponent = ({ t, type, isDoublePageMode }) => {
    const { gaEvent } = useGAEvent();
    return (
        <Button
            key={type}
            onClick={() => {
                gaEvent(isDoublePageMode ? '工具列_單頁' : '工具列_雙頁');
                toolsEventMap[type].clickHandler(isDoublePageMode);
            }}
            title={t(toolsEventMap[type].title[isDoublePageMode])}
        >
            {<Icon name={toolsEventMap[type].icon[isDoublePageMode]} />}
            <div className={styles.text}>{t(toolsEventMap[type].title[isDoublePageMode])}</div>
        </Button>
    );
};

export default withTranslation()(ReaderToolPageModeComponent);
